<template>
  <upload :action="action" @change="handleChange" :file-list="value">
    <a-button icon="upload" class="fluid">
      Załącz certyfikat
    </a-button>
  </upload>
</template>
<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    action: {
      type: String,
      required: true
    }
  },
  methods: {
    handleChange({ fileList }) {
      let fileListClone = [...fileList]

      fileListClone = fileList.map(file => {
        if (file.response) {
          return {
            file: file.response.name,
            name: file.name,
            uid: this.value.length + 1
          }
        }
        return file
      })

      this.$emit('input', fileListClone)
    }
  }
}
</script>
